<template>
  <div class="reportManage">
    <a-form layout="inline" class="form-flex">
      <a-form-item>
        <a-input
          v-model="dataForm.reportNo"
          :placeholder="$tc('lang.Reports.System_order_Nr')"
        >
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-range-picker
          v-model="dataForm.time"
          :placeholder="[
            $tc('lang.Reports.Start_from'),
            $tc('lang.Reports.End'),
          ]"
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit" @click="handleSubmit">
          {{ $tc('lang.orderAll.Serach') }}
        </a-button>
      </a-form-item>
    </a-form>
    <a-table
      :columns="columns"
      :dataSource="data"
      :scroll="{ y: 'calc(100vh - 360px)' }"
      :locale="{
        emptyText: $tc('lang.No_data'),
      }"
      style="
         width: 97%;
         margin: 20px;
        border: 1px solid #dbdbdb"
      :loading="loading"
      rowKey="reportNo"
      :pagination="{
        total: total,
        current: page,
        pageSize: size,
        onChange: onChangePage,
      }"
    >
      <span slot="planTime" slot-scope="text, record">{{
        $momentData(record.planTime)
      }}</span>
      <a-button-group slot-scope="record" slot="action">
        <a-button
          type="primary"
          title="查看"
          @click="lookReport(record)"
          size="small"
          ><a-icon type="eye" />修改评价</a-button
        >
      </a-button-group>
    </a-table>
  </div>
</template>
<script>
// 已评价
export default {
  data() {
    return {
      data: [],
      columns: [
        {
          title: this.$tc('lang.Reports.Nr'),
          align: 'center',
          width: 60,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          title: this.$tc('lang.Reports.Report_Nr'),
          dataIndex: 'reportNo',
          key: 'reportNo',
          width: 120,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Customer'),
          dataIndex: 'personName',
          key: 'personName',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Category'),
          dataIndex: 'productItems',
          key: 'productItems',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Factory'),
          key: 'factoryName',
          dataIndex: 'factoryName',
          width: 150,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Service_data'),
          key: 'planTime',
          dataIndex: 'planTime',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'planTime' },
        },
        {
          title: this.$tc('lang.Reports.Total_MD'),
          key: 'dayTime',
          dataIndex: 'dayTime',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Order_Nr'),
          key: 'orderNo',
          dataIndex: 'orderNo',
          width: 100,
          align: 'center',
        },
        {
          title: this.$tc('lang.Reports.Report'),
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: 230,
          align: 'center',
        },
      ],
      dataForm: {
        reportNo: null,
        time: [],
      },
      page: 1,
      size: 10,
      total: 0,
      loading: false,
    };
  },
  created() {
    this.dataList();
  },
  methods: {
    // 获取列表
    dataList() {
      this.loading = true;
      const userData = JSON.parse(sessionStorage.getItem('user')) || {};
      this.$http
        .post('/hzwmj/workorder-inspectreport/getPageList', {
          reportNo: this.dataForm.reportNo,
          startTime:
            this.dataForm.time.length == 0
              ? ''
              : this.dataForm.time[0].format('YYYY-MM-DD'),
          endTime:
            this.dataForm.time.length == 0
              ? ''
              : this.dataForm.time[1].format('YYYY-MM-DD'),
          page: this.page,
          size: this.size,
          personId: userData.id,
        })
        .then(data => {
          if (data != null) {
            const reastData = data.data;
            this.data = reastData.records;
            this.total = reastData.total;
            this.loading = false;
          } else {
            this.data = [];
            this.total = 0;
            this.loading = false;
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
    onChangePage(page) {
      this.page = page;
      this.dataList();
    },
    handleSubmit() {
      this.page = 1;
      this.dataList();
    },

    action(record) {
      console.log(record);
      this.$router.push({
        path: '/client/clientDetails',
        query: {
          key: record.key,
        },
      });
    },
    // 立即评价
    lookReport(record) {
      console.log(record);
      this.$router.push({
        path: '/evaluate',
        query: {
          orderId: record.orderNo,
          reportNo: record.reportNo,
          personName: record.personName,
        },
      });
    },
  },
};
</script>
<style lang="less">
.reportManage {
  padding-top: 10px;
  padding-bottom: 40px;
  border-left: 3px solid #f0f2f5;
  border-right: 2px solid #f0f2f5;
  border-bottom: 2px solid #a7a7a7;
  border-radius: 10px;
  margin-top: 3%;
  .form-flex {
    border-radius: 10px;
    border-bottom: 2px solid #a2a2a2;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
    width: 97%;
    margin: 20px;
  }
}
</style>
